"use client";
import React, {useEffect, useLayoutEffect, useState} from "react";
import {Banner} from "../components";
import {FontIcon, GuidePage} from "@/app/_components";
import type {GuidePageProps} from "@/app/_components/GuidePage/GuidePage";
import {Step1, Step2, Step3, Step4, Step5} from "@/app/_components/GuidePage/NewComer";
import {GameEntries, homeData} from "./homeData";
import GameItem from "@/app/(pages)/components/GameItem/GameItem";
import Load from "@/app/_components/Load/Load";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {
    LoginType,
    selectUserInfo,
    SET_ADD_DESKTOP_OPEN, SET_ADD_DESKTOP_REWARDS, SET_ADD_DESKTOP_REWARDS_GC,
    SET_GUIDE_OPEN,
    SET_IS_ADD_DESKTOP_OPEN,
    SET_SPECIAL_PACK_FLAG_OPEN,
    SET_STARTER_PACK_FLAG_OPEN
} from "@/app/userSlice";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {NewcomerGiftPackDialogFC} from "@/app/(shop)/UI/NewcomerGiftPackDialog/NewcomerGiftPackDialog";
import {getToken, getUserId} from "@/app/utils/auth";
import {PwaGuideDialogFC} from "@/app/(shop)/UI/PwaGuideDialog/PwaGuideDialogFC";
import {FirstChargeGiftPackDialogFC} from "@/app/(shop)/UI/FirstChargeGiftPackDialog/FirstChargeGiftPackDialog";
import {selectShopItems} from "@/app/(pages)/shopItemsSlice";
import {SpecialGiftPackDialogFC} from "@/app/(shop)/UI/SpecialGiftPackDialog/SpecialGiftPackDialog";
import KitPwa, {PwaMsgType} from "@/Master/PWA/KitPwa";
import RewardApply from "@/Core/Reward/RewardApply";
import {RewardSource} from "@/Core/Reward/RewardInfo";
import EventManager from "@/Fwk/EventManager";
import TrackCommon2 from "@/Core/Track/TrackCommon2";
import $http from "@/app/_api";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import styles from "./page.module.css";
import GameTrack from "@/Core/GameTrack";
import UtilBrowser from "@/Master/UtilBrowser";
import {RewardDialogFC} from "@/app/_dialogs/RewardDialog/RewardDialog";
import Util from "@/Master/Util";
import {AccountSelectionDialogFC} from "@/app/_dialogs/AccountSelectionDialog/AccountSelectionDialog";
import {PrivacyDialogFC} from "@/app/_dialogs/PrivacyDialog/PrivacyDialog";
import HomeTips from "@/app/(pages)/components/HomeTips/HomeTips";
import BigTips from "@/Master/BigTips";

const guideSteps: GuidePageProps['steps'] = [
    {
        content: <Step1 currIndex={0} target={() => document.querySelector('#guideStep1_2')}/>,
    },
    {
        content: <Step2 currIndex={1} target={() => document.querySelector('#guideStep1_2')}/>,
    },
    {
        content: <Step3 currIndex={2} target={() => document.querySelector('#guideStep3')}/>,
    },
    {
        content: <Step4 currIndex={3} target={() => document.querySelector('#guideStep4')}/>,
    },
    {
        content: <Step5 currIndex={4} target={() => document.querySelector('#guideStep5')}/>,
    },
]

export default function HomePage() {
    const userInfo = useAppSelector(selectUserInfo);
    const shopItem = useAppSelector(selectShopItems);
    const dispatch = useAppDispatch();

    const [hotGameList, setHotGameList] = useState<GameEntries[]>([]);
    const [topGameList, setTopGameList] = useState<GameEntries[]>([]);

    useLayoutEffect(() => {
        const hasToken = getToken()
        !hasToken && window.location.reload()

    }, []);

    useEffect(() => {
        if(userInfo.addDesktopRewards === 0){
            RewardApply.Instance.RequestRewardConfig(RewardSource.AddDesktop, (data) => {
                if(data.code === 200){
                    if(Util.isLog){
                        console.log('RequestRewardConfig',data.data)
                        console.log('rewards===dispatch(SET_ADD_DESKTOP_REWARDS(data.data.scBonus))')
                    }
                    dispatch(SET_ADD_DESKTOP_REWARDS(data.data.scBonus))
                    dispatch(SET_ADD_DESKTOP_REWARDS_GC(data.data.gcBonus))
                }
            })
        }

        EventManager.addEventListener(PwaMsgType.onInstallSuccess, onAcceptInstall);
        return()=>{
            EventManager.removeEventListener(PwaMsgType.onInstallSuccess, onAcceptInstall);
        }
    }, [userInfo]);

    const onAcceptInstall = (event: any) => {
        if (Util.isLog) {
            console.log('shortcutDialog==onAcceptInstall', event.detail)
            console.log('shortcutDialog==isPlayPwa==isDesktop', KitPwa.isPlayPwa && UtilBrowser.isDesktop)
        }
        if (Util.isLog){
            console.log('event',event.detail)
        }
        //桌面pwa展示奖励
        if (KitPwa.isPlayPwa && UtilBrowser.isDesktop) {
            if (Util.isLog) {
                console.log('onVisibilitychangeShow', 'KitPwa.isPlayPwa && UtilBrowser.isDesktop:' + KitPwa.isPlayPwa && UtilBrowser.isDesktop)
            }
            if (event.detail.isReward) {
                SDialogManagerFC.openDialog(RewardDialogFC, {
                    fcKey: SDialogManagerFC.getFCKey(RewardDialogFC),
                    gcCount: userInfo.addDesktopRewardsGC,
                    scCount: userInfo.addDesktopRewards,
                    onClose: () => {
                        KitPwa.openPWA();
                    }
                })
            } else {
                if (Util.isLog){
                    console.log("event.detail",event.detail)
                }
                KitPwa.openPWA();// 没有奖励就刷新
            }
            return
        }
        //android 逻辑
        showForceLoading();

        setTimeout(() => {
            if (Util.isLog) {
                console.log('home/page', `GuidePWA => KitPwa.pwaStatus=${KitPwa.pwaStatus}`)
            }
            hideForceLoading()
            if(event.detail.isReward && !UtilBrowser.isDesktop){
                SDialogManagerFC.openDialog(RewardDialogFC,{
                    fcKey:SDialogManagerFC.getFCKey(RewardDialogFC),
                    gcCount:userInfo.addDesktopRewardsGC,
                    scCount:userInfo.addDesktopRewards,
                })
            }
        }, 10000);
    }

    const onGuideEnd = () => {
        // GuideMgr.setGuideId(GuideIDType.guide_end);
        // setGuideOpen(false);
        dispatch(SET_GUIDE_OPEN(false));
        showForceLoading();
        getRewardsData().then((data) => {
            const { gcBonus, scBonus } = data;
            // setGcBonus(gcBonus);
            // setScBonus(scBonus);
            if (userInfo.addDesktopRewards > 0) {
                GameTrack.showNewbieReward();
                SDialogManagerFC.openDialog(NewcomerGiftPackDialogFC,{
                    fcKey:SDialogManagerFC.getFCKey(NewcomerGiftPackDialogFC),
                    onClose:()=>{
                        SDialogManagerFC.openDialog(PwaGuideDialogFC, {
                            fcKey: SDialogManagerFC.getFCKey(PwaGuideDialogFC),
                        });
                        dispatch(SET_IS_ADD_DESKTOP_OPEN(true))
                    },
                    scBonus,
                    gcBonus,
                })
            }
        });
        // console.log(GET_USER_INFO());
    }

    const getRewardsData = async () => {
        const data = await $http.Rewards.getRewardsConfig({rewardSource: 102});
        hideForceLoading();
        return data;
    }

    useEffect(() => {

        const {vipLevel} = userInfo;

        let list = homeData;
        let hotList:any[] = [];
        let topList:any[] = [];

        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            const {preVipLevel,openVipLevel} = item;
            item.index = item.smallSort;
            item.isLocking = false;
            if (vipLevel < preVipLevel) {
                continue;
            }
            if (vipLevel >= preVipLevel){
                if (vipLevel < openVipLevel){
                    item.isLocking = true;
                    item.index = 10000+item.smallSort;
                }
            }
            switch (item.type) {
                case 1:
                    hotList.push(item);
                    break;
                case 2:
                    topList.push(item);
                    break;
                default:
                    break;
            }
        }

        topList.sort((a,b) => a.index - b.index);
        hotList.sort((a,b) => a.index - b.index);

        setHotGameList(hotList);
        setTopGameList(topList);

    }, [homeData, userInfo.vipLevel])

    useEffect(() => {
        if (userInfo.loginType === LoginType.visitor) {
            if (userInfo.vipLevel > 0 || userInfo.vipExp > 0) return;
        }
        if(Util.isLog){
            console.log("KitPwa.isPlayPwa && !userInfo.addDesktopRewards",KitPwa.isPlayPwa && !userInfo.addDesktopRewards)
        }
        if(KitPwa.isPlayPwa && !userInfo.addDesktopOpen){
            //进入pwa状态都发送请求领取奖励，领取过则忽略
            RewardApply.Instance.RequestRewardApply(RewardSource.AddDesktop, (data) => {
                if(data.code === 200){
                    const detail = {
                        isReward:data.code ===  200,
                        gcCount:userInfo.addDesktopRewardsGC,
                        scCount:userInfo.addDesktopRewards
                    }
                    EventManager.dispatchEvent(PwaMsgType.onClaimInstalledReward,detail)
                }
            })
        }
        if (!userInfo.isGuide && SDialogManagerFC.dialogsCount === 0 && !userInfo.guideOpen && !userInfo.firstRequestUserInfo) {
            SDialogManagerFC.openDialog(AccountSelectionDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(AccountSelectionDialogFC),
                callToLogin: () => {
                    GameTrack.closeWelcome();
                    GameTrack.showPrivacy();
                    SDialogManagerFC.openDialog(PrivacyDialogFC, {
                        fcKey: SDialogManagerFC.getFCKey(PrivacyDialogFC),
                        callAccept: () => {
                            GameTrack.clickAgreePrivacy();
                            dispatch(SET_GUIDE_OPEN(true))
                        },
                        onClose: () => {
                            GameTrack.clickClosePrivacy()
                            dispatch(SET_GUIDE_OPEN(true))
                        }
                    })
                }
            });
        }
        if (
            userInfo.isGuide
            && shopItem.shopItemsStarterData.length > 0
            && shopItem.shopItemsSpecialData.length > 0
            && !userInfo.isAddDesktopOpen
        ) {
            if (!userInfo.isAddDesktopOpen) {
                if (!userInfo.addDesktopOpen) {
                    SDialogManagerFC.openDialog(PwaGuideDialogFC, {
                        fcKey: SDialogManagerFC.getFCKey(PwaGuideDialogFC),
                        onClose: () => {
                            dispatch(SET_IS_ADD_DESKTOP_OPEN(true));
                            if (!userInfo.starterPackFlag) {
                                SDialogManagerFC.openDialog(FirstChargeGiftPackDialogFC, {
                                    fcKey: SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC),
                                    onClose: () => {
                                        // 查询是否充值首充礼包
                                        if (userInfo.starterPackFlag) return false;
                                        SDialogManagerFC.openDialog(SpecialGiftPackDialogFC, {
                                            fcKey: SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC),
                                            onClose: () => {

                                            },
                                            userId: getUserId(),
                                            shopItemsSpecialData: shopItem.shopItemsSpecialData,
                                            dispatcher: dispatch
                                        })
                                    },
                                    shopItemsStarterData: shopItem.shopItemsStarterData,
                                    userId: getUserId(),
                                    dispatcher: dispatch
                                })
                            }
                            if (userInfo.starterPackFlag) {
                                SDialogManagerFC.openDialog(SpecialGiftPackDialogFC, {
                                    fcKey: SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC),
                                    onClose: () => {

                                    },
                                    userId: getUserId(),
                                    shopItemsSpecialData: shopItem.shopItemsSpecialData,
                                    dispatcher: dispatch
                                })
                            }
                        },
                    })

                }
            } else {
                if (!userInfo.starterPackFlag && !userInfo.starterPackFlagOpen) {
                    TrackCommon2.iapPageShow(2)
                    SDialogManagerFC.openDialog(FirstChargeGiftPackDialogFC, {
                        fcKey: SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC),
                        onClose: () => {
                            dispatch(SET_STARTER_PACK_FLAG_OPEN(true))
                            SDialogManagerFC.openDialog(SpecialGiftPackDialogFC, {
                                fcKey: SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC),
                                onClose: () => {
                                    dispatch(SET_SPECIAL_PACK_FLAG_OPEN(true))
                                },
                                userId: getUserId(),
                                shopItemsSpecialData: shopItem.shopItemsSpecialData,
                                dispatcher: dispatch
                            })
                        },
                        shopItemsStarterData: shopItem.shopItemsStarterData,
                        userId: getUserId(),
                        dispatcher: dispatch
                    })
                } else {
                    TrackCommon2.iapPageShow(2)
                    if (!userInfo.specialPackFlagOpen) {
                        SDialogManagerFC.openDialog(SpecialGiftPackDialogFC, {
                            fcKey: SDialogManagerFC.getFCKey(SpecialGiftPackDialogFC),
                            onClose: () => {
                                dispatch(SET_SPECIAL_PACK_FLAG_OPEN(true))
                            },
                            userId: getUserId(),
                            shopItemsSpecialData: shopItem.shopItemsSpecialData,
                            dispatcher: dispatch
                        })
                    }
                }
            }
        }
    }, [userInfo, shopItem])

    return (
        <div className={styles.page}>
            <Banner/>
            <HomeTips/>

            <section className={styles.game_list_wrapper}>
                <p className={styles.game_list_title}>
                    <FontIcon icon={'s-fire item-color'}></FontIcon>
                    <span style={{margin: '0.25rem 0.4rem',color:'#ffffff'}}>HOT GAMES</span>
                    <FontIcon icon={'s-fire item-color'}></FontIcon>
                </p>
                {
                     hotGameList && hotGameList.length > 0 ? (
                        <div className={styles.game_list_grid}>
                            {hotGameList.map((item, key) => (
                                <GameItem data={item} key={key}/>
                            ))}
                        </div>
                    ) : <Load/>
                }
            </section>

            <section className={styles.game_list_wrapper}>
                <p className={styles.game_list_title}>
                    <FontIcon icon={'s-medal item-color'}></FontIcon>
                    <span style={{margin: '0.25rem 0.4rem',color:'#ffffff'}}>TOP GAMES</span>
                    <FontIcon icon={'s-medal item-color'}></FontIcon>
                </p>
                {
                    topGameList && topGameList.length > 0 ? (
                        <div className={styles.game_list_grid}>
                            {topGameList.map((item, key) => (
                                <GameItem data={item} key={key}/>
                            ))}
                        </div>
                    ) : <Load/>
                }
            </section>

            <GuidePage open={userInfo.guideOpen} steps={guideSteps} onGuideEnd={onGuideEnd}/>

            <div className={'header_panel'}></div>
        </div>
    )
}
